/*=========================================================================================
  File Name: moduleReportForm.js
  Description: Report FormModule

==========================================================================================*/

import state from "./moduleReportFormState.js";
import actions from "./moduleReportFormActions.js";
import getters from "./moduleReportFormGetters.js";
import mutations from "./moduleReportFormMutations.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
